import React from "react"
import { routePaths } from "../.."
import { OrgAuthCheck } from "../../../Components/Common/AuthCheck/OrgAuthCheck"
import { defaultWorkerGroupSort } from "../../../Components/Views/Dashboard/Sections/Worker/Common/constants"
import { WorkerGroupList } from "../../../Components/Views/Dashboard/Sections/Worker/WorkerGroupList"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { OrgRouteComponentProps } from "../../RouteProps"

export function WorkerGroupListRoute({
    match,
    location
}: OrgRouteComponentProps<{}>) {
    const { sort } = useDecodeFilterAndSort(
        location.search,
        defaultWorkerGroupSort,
        routePaths.orgWorkerGroupList(match.params.orgUsername)
    )

    return (
        <OrgAuthCheck
            orgUsername={match.params.orgUsername}
            scope="worker:view"
        >
            <WorkerGroupList
                orgUsername={match.params.orgUsername}
                showAddModal={false}
                sort={sort}
            />
        </OrgAuthCheck>
    )
}
